import * as noUiSlider from '../../../../../node_modules/nouislider';
import { PhotoshopController } from '../../../../photoshopController.js';
import { ParametersWidget } from './parameterWidget.js';

declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}
export class LevelsParameterWidget extends ParametersWidget {

    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = LevelsParameterWidget.html();
        super.initEvent();

        this.updateModel();
        this.initializeLevelsRange();
    }

    static html() {
        return super.header() +
            '\
        <div id="levels" style="display: none; padding: 10px;">\
            <h4 class="center-align">Niveaux</h4>\
            <div class="col s12 divider row"></div>\
            <div class="col s12 no-padding row">\
                <canvas id="histogram" style="max-height: 200px; width: 100%; background-color: #454545"></canvas>\
            </div>\
            <div class="col s12" style="display: inline-block;">\
                <div id="levels-input-range" class="col s12 row"></div>\
                <input id="levels-input-min" class="col s3 left" type="number" min="0">\
                <input id="levels-input-max" class="col s3 right" type="number" max="255">\
            </div>\
            <div class="col s12" style="margin-top: 20px;">\
                <div id="levels-exponent-range" class="col s12 row"></div>\
            </div>\
            <div class="col s12 no-padding" style="margin-bottom: 10px;">\
                <input id="levels-exponent-input" class="col s3 offset-s4 center-block" type="number" step="0.01">\
            </div>\
            <div class="col s12 divider row"></div>\
            <p>Niveaux de sortie</p>\
            <div class="col s12">\
                <div id="levels-output-range" class="col s12 row"></div>\
                <input id="levels-output-min" class="col s3 left" type="number" min="0">\
                <input id="levels-output-max" class="col s3 right" type="number" max="255">\
            </div>\
        </div>\
        ' + super.footer();
    }

    levels_input_minOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.inputMin = value;
        this.photoshopController.update();
    }

    levels_input_maxOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.inputMax = value;
        this.photoshopController.update();
    }

    levels_exponent_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.exponent = value;
        this.photoshopController.update();
    }

    levels_output_minOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.outputMin = value;
        this.photoshopController.update();
    }

    levels_output_maxOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.outputMax = value;
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {
            if (this.photoshopController.PSEngine.activeOperation.inputMin !== undefined) {
                const levelsInputMin = document.getElementById("levels-input-min") as HTMLInputElement | null;
                if (levelsInputMin) {
                    levelsInputMin.valueAsNumber = this.photoshopController.PSEngine.activeOperation.inputMin;
                    levelsInputMin.max = this.photoshopController.PSEngine.activeOperation.inputMax;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.inputMax !== undefined) {
                const levelsInputMax = document.getElementById("levels-input-max") as HTMLInputElement | null;
                if (levelsInputMax) {
                    levelsInputMax.valueAsNumber = this.photoshopController.PSEngine.activeOperation.inputMax;
                    levelsInputMax.min = this.photoshopController.PSEngine.activeOperation.inputMin;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.exponent !== undefined) {
                const levelsExponentInput = document.getElementById("levels-exponent-input") as HTMLInputElement | null;
                if (levelsExponentInput) {
                    levelsExponentInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.exponent;
                    levelsExponentInput.min = this.photoshopController.PSEngine.activeOperation.minExponent;
                    levelsExponentInput.max = this.photoshopController.PSEngine.activeOperation.maxExponent;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.outputMin !== undefined) {
                const levelsOutputMin = document.getElementById("levels-output-min") as HTMLInputElement | null;
                if (levelsOutputMin) {
                    levelsOutputMin.valueAsNumber = this.photoshopController.PSEngine.activeOperation.outputMin;
                    levelsOutputMin.max = this.photoshopController.PSEngine.activeOperation.outputMax;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.outputMax !== undefined) {
                const levelsOutputMax = document.getElementById("levels-output-max") as HTMLInputElement | null;
                if (levelsOutputMax) {
                    levelsOutputMax.valueAsNumber = this.photoshopController.PSEngine.activeOperation.outputMax;
                    levelsOutputMax.min = this.photoshopController.PSEngine.activeOperation.outputMin;
                }
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        super.updateIf();
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'levels') {
            const levelsElement = document.getElementById("levels");
            if (levelsElement) {
                levelsElement.style.display = "";
            }
        } else {
            const levelsElement = document.getElementById("levels");
            if (levelsElement) {
                levelsElement.style.display = "none";
            }
        }
    }

    initializeLevelsRange() {
        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
            return;
        }
            var inputRange = document.getElementById("levels-input-range");
            if (inputRange) {
                if (inputRange.noUiSlider) {
                    inputRange.noUiSlider.destroy();
                }
                noUiSlider.create(inputRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.inputMin, this.photoshopController.PSEngine.activeOperation.inputMax],
                    connect: true,
                    step: 1,
                    orientation: 'horizontal',
                    range: {
                        min: 0,
                        max: 255
                    }
                });
                if (inputRange.noUiSlider) {
                    inputRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.inputMin = Number(values[0]);
                        this.photoshopController.PSEngine.activeOperation.inputMax = Number(values[1]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const levelsInputMin = document.getElementById('levels-input-min');
                if (levelsInputMin) {
                    levelsInputMin.addEventListener('change', function (event) {
                        this.levels_input_minOnChange(event.currentTarget.value);
                        if (inputRange && inputRange.noUiSlider) {
                            inputRange.noUiSlider.set([event.currentTarget.value, this.photoshopController.PSEngine.activeOperation.inputMax]);
                        }
                    }.bind(this));
                }
                const levelsInputMax = document.getElementById('levels-input-max');
                if (levelsInputMax) {
                    levelsInputMax.addEventListener('change', function (event) {
                        this.levels_input_maxOnChange(event.currentTarget.value);
                        if (inputRange && inputRange.noUiSlider) {
                            inputRange.noUiSlider.set([this.photoshopController.PSEngine.activeOperation.inputMin, event.currentTarget.value]);
                        }
                    }.bind(this));
                }
            }
            var outputRange = document.getElementById("levels-output-range");
            if (outputRange) {
                if (outputRange.noUiSlider) {
                    outputRange.noUiSlider.destroy();
                }
                noUiSlider.create(outputRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.outputMin, this.photoshopController.PSEngine.activeOperation.outputMax],
                    connect: true,
                    step: 1,
                    orientation: 'horizontal',
                    range: {
                        min: 0,
                        max: 255
                    }
                });
                if (outputRange.noUiSlider) {
                    outputRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.outputMin = Number(values[0]);
                        this.photoshopController.PSEngine.activeOperation.outputMax = Number(values[1]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const levelsOutputMin = document.getElementById('levels-output-min');
                if (levelsOutputMin) {
                    levelsOutputMin.addEventListener('change', function (event) {
                        this.levels_output_minOnChange(event.currentTarget.value);
                        if (outputRange && outputRange.noUiSlider) {
                            outputRange.noUiSlider.set([event.currentTarget.value, this.photoshopController.PSEngine.activeOperation.outputMax]);
                        }
                    }.bind(this));
                }
                const levelsOutputMax = document.getElementById('levels-output-max');
                if (levelsOutputMax) {
                    levelsOutputMax.addEventListener('change', function (event) {
                        this.levels_output_maxOnChange(event.currentTarget.value);
                        if (outputRange && outputRange.noUiSlider) {
                            outputRange.noUiSlider.set([this.photoshopController.PSEngine.activeOperation.outputMin, event.currentTarget.value]);
                        }
                    }.bind(this));
                }
            }
            var exponentRange = document.getElementById("levels-exponent-range");
            if (exponentRange) {
                if (exponentRange.noUiSlider) {
                    exponentRange.noUiSlider.destroy();
                }
                noUiSlider.create(exponentRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.exponent],
                    step: 0.01,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minExponent,
                        max: this.photoshopController.PSEngine.activeOperation.maxExponent
                    }
                });
                if (exponentRange.noUiSlider) {
                    exponentRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.exponent = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const levelsExponentInput = document.getElementById('levels-exponent-input');
                if (levelsExponentInput) {
                    levelsExponentInput.addEventListener('change', function (event) {
                        this.levels_exponent_inputOnChange(event.currentTarget.value);
                        if (exponentRange && exponentRange.noUiSlider) {
                            exponentRange.noUiSlider.set([event.currentTarget.value]);
                        }
                    }.bind(this));
                }
            }
        });
    }

    reglages_undoOnClick() {
        super.reglages_undoOnClick();
        this.updateModel();
        this.updateIf();
        this.initializeLevelsRange();
    }
}